export default __webpack_public_path__ + "static/media/Ben_Resume.866f91f1.pdf";